import { boronClient } from "../../../../api";
import { useBoronMutation } from "../../../../hooks/http/useBoronMutation";
import { useDeleteSectionStaysCache } from "../../useFetchSectionStays";

export const useDeleteSectionStay = ({ sectionId }: { sectionId: string }) => {
  const { deleteSectionStaysCache } = useDeleteSectionStaysCache({
    sectionId,
  });

  return useBoronMutation(
    async (stayId: string) =>
      await boronClient.DELETE(
        "/api/v1/sections/{section_id}/stays/{stay_hashid}",
        {
          params: {
            path: {
              section_id: sectionId,
              stay_hashid: stayId,
            },
          },
        },
      ),
    {
      onSuccess: (_, stayId) => {
        deleteSectionStaysCache(stayId);
      },
    },
  );
};
